/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["company-modules{width:100%}.PriceContent{width:100%;justify-content:center;height:auto;overflow:auto;overflow-x:hidden;display:block}@media screen and (min-width:1280px){.PriceContent .price-wrapper{justify-content:center}}.PriceContentMessage{padding:0 0 1rem}.Island-price{flex-direction:column}.Island-price .priceAlert{padding:5px 0}.Island-price .priceAlert .main{width:auto}.Island-price .priceAlert .sticky-parent-helper{width:260px}"];
export { styles as styles };
